/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2018
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define('collaboration/canvaseditor/shapes/PenShape',['underscore', './Shape', 'fabric'], function (_, Shape) {
	'use strict';

	var PenShape = Shape.extend({

		/**
   * Called by constructor.
   * @param options {Object} Options
   */
		init: function init(options) {
			PenShape.inherited('init', this, arguments);

			this.originalX = options.xCoord;
			this.originalY = options.yCoord;
		},

		createPath: function createPath(pen) {
			pen.set(_.extend({}, this.defaultAttributes, {
				figure: 'pen',
				strokeWidth: 3
			}));

			if (pen.width === 0) {
				pen.set({ width: this.defaultWidth });
			}

			if (pen.height === 0) {
				pen.set({ height: this.defaultHeight });
			}

			pen.setCoords();
			this.shape = pen;
			return pen;
		}
	});

	PenShape.drawControlsVisibility = function (canvas, shape) {
		shape.setControlsVisibility({
			mtr: true,
			mb: true,
			mt: true,
			ml: true,
			mr: true,
			tl: true,
			br: true,
			tr: true,
			bl: true
		});
	};

	PenShape.scale = function (shape) {
		if (!shape.strokeWidthUnscaled && shape.strokeWidth) {
			shape.strokeWidthUnscaled = shape.strokeWidth;
		}
		if (shape.strokeWidthUnscaled) {
			// This is an aproximation of a scaled 3px stroke that looks good enough
			shape.strokeWidth = shape.strokeWidthUnscaled / ((shape.scaleX + shape.scaleY) / 2);
		}
	};

	PenShape.canUpdate = function () {
		return true;
	};

	PenShape.canSkew = function () {
		return false;
	};

	PenShape.handleEnterKeyEvent = function (shape) {}; // eslint-disable-line no-unused-vars

	return PenShape;
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

